export default __webpack_public_path__ + "static/5-grayscale-421e25a06b0b3ad0da82401593878d9f.png";